// Utility: Transform API extraButtons to flat form state for all redirection types
import { ExtraButton } from '../types';

export function transformExtraButtonsFromApi(extraButtons: any[]): ExtraButton[] {
  return (extraButtons || []).map((btn) => {
    // If button already has redirectionType (new format), preserve tournamentSeason and seasonName
    if (btn.redirectionType) {
      return {
        ...btn,
        tournamentSeason: btn.tournamentSeason || '',
        // Map tournamentSeasonName from API to seasonName, or use existing seasonName
        // If tournamentSeasonName is not present, it's likely a DEFAULT season, so don't set seasonName
        seasonName: btn.tournamentSeasonName || btn.seasonName || undefined,
      };
    }
    if (btn.category === 'share' && btn.redirection && btn.redirection.type === 'share') {
      return {
        ...btn,
        redirectionType: 'share',
      };
    }
    if (btn.category === 'button' && btn.redirection) {
      const { type, path, tabIndex } = btn.redirection;
      // WeeklyReport
      if (type === 'page' && path && path.includes('/viewWeeklyReport')) {
        const params = new URLSearchParams(path.split('?')[1]);
        return {
          ...btn,
          redirectionType: 'WeeklyReport',
          weeklyReportId: params.get('reportId') || '',
          weeklyReportName: btn.weeklyReportName || btn.label || '',
        };
      }
      // AcademyDetailsScreen
      if (type === 'page' && path && path.includes('/academyDetailScreen')) {
        const params = new URLSearchParams(path.split('?')[1]);
        return {
          ...btn,
          redirectionType: 'AcademyDetailsScreen',
          academyId: params.get('academyId') || '',
          academyName: decodeURIComponent(params.get('title') || ''),
          coachingCenterId: params.get('coachingCenterId') || '',
          location: params.get('location') || '',
          academyLocation: params.get('location') || '',
        };
      }
      // Academy (tab type)
      if (type === 'tab') {
        return {
          ...btn,
          redirectionType: 'Academy',
          tabIndex: tabIndex,
        };
      }
      // TournamentScreen and TournamentTab (legacy: type === 'page')
      if (type === 'page' && path && path.includes('/tournamentMainScreen')) {
        const params = new URLSearchParams(path.split('?')[1]);
        const tabName = params.get('tabName');
        
        // Extract tournamentSeasonId and tournamentSeasonName from URL params (same way as tournamentName)
        const tournamentSeasonIdFromParams = params.get('tournamentSeasonId') || '';
        const tournamentSeasonNameFromParams = params.get('tournamentSeasonName') 
          ? decodeURIComponent(params.get('tournamentSeasonName') || '') 
          : '';
        
        if (tabName) {
          // TournamentTab
          const transformed = {
            ...btn,
            redirectionType: 'TournamentTab',
            tournamentId: params.get('tournamentId') || btn.tournamentId || '',
            tournamentName: decodeURIComponent(params.get('tournamentName') || '') || btn.tournamentName || '',
            sports: params.get('sports') || btn.sports || '',
            tabName: tabName,
            tabType: params.get('tabType') || btn.tabType || '',
            tournamentSeason: tournamentSeasonIdFromParams || btn.tournamentSeason || '',
            // Extract seasonName from URL params (tournamentSeasonName), same way as tournamentName
            seasonName: tournamentSeasonNameFromParams || btn.tournamentSeasonName || btn.seasonName || undefined,
          };
          console.log('Transformed TournamentTab (legacy):', transformed);
          return transformed;
        } else {
          // TournamentScreen
          const transformed = {
            ...btn,
            redirectionType: 'TournamentScreen',
            tournamentId: params.get('tournamentId') || btn.tournamentId || '',
            tournamentName: decodeURIComponent(params.get('tournamentName') || '') || btn.tournamentName || '',
            sports: params.get('sports') || btn.sports || '',
            tournamentSeason: tournamentSeasonIdFromParams || btn.tournamentSeason || '',
            // Extract seasonName from URL params (tournamentSeasonName), same way as tournamentName
            seasonName: tournamentSeasonNameFromParams || btn.tournamentSeasonName || btn.seasonName || undefined,
          };
          console.log('Transformed TournamentScreen (legacy):', transformed);
          return transformed;
        }
      }
      // URL
      if (
        type === 'URL' ||
        type === 'url' ||
        (type === 'page' && path && /^https?:\/\//.test(path))
      ) {
        return {
          ...btn,
          redirectionType: 'URL',
          url: path || '',
        };
      }
      // Generic page path redirection
      if (type === 'page' && path) {
        return {
          ...btn,
          redirectionType: 'Page',
          page: path,
        };
      }
      // Generic custom redirection: preserve raw type/path for edit
      if (type && path) {
        return {
          ...btn,
          redirectionType: 'Custom',
          customType: type,
          customPath: path,
        };
      }
      // Fallback: use type as redirectionType if present
      if (type) {
        return {
          ...btn,
          redirectionType: type,
        };
      }
    }
    return btn;
  });
} 